import {
  OvlAddComponent,
  OvlAddScreen,
} from "../../../../../../_ovlclient/src/global/globals"
import { CompFeedbackForm } from "../../screens/datdocuments/feedback/feedbackform"
import { CompDPInvoiceOverview } from "../../screens/datdocuments/invoice/dpinvoiceoverview"
import { CompInvoiceOverview } from "../../screens/datdocuments/invoice/invoiceoverview"
import { CompOrderDetail } from "../../screens/datdocuments/order/orderdetail"
import { CompOrderDetailLayout } from "../../screens/datdocuments/order/orderdetaillayout"
import { CompOrderFeedback } from "../../screens/datdocuments/order/orderfeedback"
import { CompOrderOverview } from "../../screens/datdocuments/order/orderoverview"
import { CompOrderTimeLine } from "../../screens/datdocuments/order/ordertimeline"
import { CompQuotationOverview } from "../../screens/datdocuments/quotation/quotationoverview"
import { ScreenSearchPaket } from "../../screens/datdocuments/searchpaket/searchpaket"

export const DATDocuments_Init = () => {
  OvlAddComponent("comp-orderfeedback", CompOrderFeedback)
  OvlAddComponent("comp-orderdetail", CompOrderDetail)
  OvlAddComponent("comp-ordertimeline", CompOrderTimeLine)
  OvlAddComponent("comp-dpinvoiceoverview", CompDPInvoiceOverview)

  OvlAddScreen(CompQuotationOverview, "DATQuotation")
  OvlAddScreen(CompOrderOverview, "DATOrder")
  OvlAddScreen(CompInvoiceOverview, "DATInvoice")

  OvlAddScreen(CompOrderDetailLayout, "DATOrderdetail")

  OvlAddScreen(CompFeedbackForm, "DATFeedback")

  OvlAddScreen(ScreenSearchPaket, "DATSearchPaket")
}
